import { render, staticRenderFns } from "./ItemsListImportModal.vue?vue&type=template&id=8ed04c28&scoped=true"
import script from "./ItemsListImportModal.vue?vue&type=script&lang=js"
export * from "./ItemsListImportModal.vue?vue&type=script&lang=js"
import style0 from "./ItemsListImportModal.vue?vue&type=style&index=0&id=8ed04c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed04c28",
  null
  
)

export default component.exports